import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"color":"#fa8c16","margin-bottom":"12px"}
}

import { ref, watch } from "vue";
import { message } from "ant-design-vue";
import { getCurrentTimestamp } from "@/utils/solt/timestamp";
import { sortByMd5WithSalt } from "@/utils/solt";
import { updateUserInfo } from "@/api/user";

interface Props {
  visible: boolean;
  force?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PassWord',
  props: {
    visible: { type: Boolean },
    force: { type: Boolean }
  },
  emits: ["close", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const loading = ref<boolean>(false);
const newPassword = ref<string>("");
const confirmPassword = ref<string>("");

watch(
  () => props.visible,
  (val) => {
    if (!val) {
      newPassword.value = "";
      confirmPassword.value = "";
    }
  },
);

/** 仅允许通过关闭按钮关闭：拦截遮罩等非主动关闭 */
const handleUpdateOpen = (open: boolean) => {
  if (!open) {
    // 不在这里关闭，统一走 handleClose / @cancel
    return;
  }
};

const handleClose = () => {
  emit("close");
};

const handleOk = async () => {
  if (!newPassword.value || !confirmPassword.value) {
    message.info("请填写完整密码");
    return;
  }
  if (newPassword.value !== confirmPassword.value) {
    message.info("两次密码不一致");
    return;
  }
  if (newPassword.value === "123456") {
    message.error("密码过于简单，请设置更复杂的密码");
    return;
  }
  loading.value = true;
  try {
    const time = await getCurrentTimestamp();
    const obj = {
      password: newPassword.value,
      repassword: confirmPassword.value,
      timestamp: time,
    };
    const sign = await sortByMd5WithSalt(obj);
    const res = await updateUserInfo({
      password: newPassword.value,
      repassword: confirmPassword.value,
      timestamp: time,
      sign: sign,
    });
    if (res?.code == 200) {
      message.success(res?.msg || "修改成功");
      try {
        const userInfo = JSON.parse(localStorage.getItem("UserInfo") || "{}");
        userInfo.must_change_password = 0;
        localStorage.setItem("UserInfo", JSON.stringify(userInfo));
      } catch (e) {}
      emit("success");
      emit("close");
    } else {
      message.info(res?.msg);
    }
  } catch (error) {
    console.error("更新失败", error);
  } finally {
    loading.value = false;
  }
};


return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      open: _ctx.visible,
      title: _ctx.force ? '请修改密码' : '修改密码',
      closable: true,
      maskClosable: false,
      keyboard: false,
      onCancel: handleClose,
      "onUpdate:open": handleUpdateOpen
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "back",
          onClick: handleClose
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("关闭")
          ])),
          _: 1
        }),
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          loading: loading.value,
          onClick: handleOk
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("提交")
          ])),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        (_ctx.force)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, " 当前为简易默认密码（123456），请修改后再继续使用 "))
          : _createCommentVNode("", true),
        _cache[4] || (_cache[4] = _createElementVNode("p", null, "请输入您的新密码：", -1)),
        _createVNode(_component_a_input_password, {
          value: newPassword.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((newPassword).value = $event)),
          placeholder: "新密码"
        }, null, 8, ["value"]),
        _cache[5] || (_cache[5] = _createElementVNode("p", { style: {"margin-top":"12px"} }, "请确认您的新密码：", -1)),
        _createVNode(_component_a_input_password, {
          value: confirmPassword.value,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((confirmPassword).value = $event)),
          placeholder: "确认新密码"
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["open", "title"])
  ]))
}
}

})